import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const qqMusic: MusicService = {
  id: 'qq-music',
  name: 'QQ Music (QQ 音乐)',
  shortName: 'QQ音乐',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: false,
  color: {
    primary: '#fbdc4b',
    label: '#F8D124',
    background: '#8d876d',
    text: '#e4c73f',
  },
  importerID: ImporterID.QQMusic,
  musicAPIID: MusicAPIIntegrationID.QQMusic,
  linkType: 'qqmusic',
  assets: {
    logo: { light: 'qq-light.svg', dark: 'qq-dark.svg' },
    logoPadding: { light: 'qq-light-padding.svg', dark: 'qq-dark-padding.svg' },
    logoColor: { light: 'qq-color-light.svg', dark: 'qq-color-dark.svg' },
    logoColorPadding: {
      light: 'qq-color-light-padding.svg',
      dark: 'qq-color-dark-padding.svg',
    },
    logoOnBackground: 'qq-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.qqMusicWhatIs,
};
